var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleBrokenDownLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00017 9.00001V15M9.00017 15H15.0002M9.00017 15L19 4.99995M21.6606 9.41045C22.5515 12.7466 21.6883 16.4538 19.071 19.0711C15.1658 22.9763 8.83412 22.9763 4.92887 19.0711C1.02363 15.1658 1.02363 8.83418 4.92887 4.92893C7.54616 2.31164 11.2533 1.44846 14.5895 2.33938",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleBrokenDownLeft);
export default __webpack_public_path__ + "static/media/arrow-circle-broken-down-left.d5c96b93cd90f91e3741e3c12f67ed88.svg";
export { ForwardRef as ReactComponent };